import React from 'react'
import { Skeleton } from '@fs/zion-ui'

export default (
  <>
    <Skeleton.H3 maxWidth={window.innerWidth} />
    {Array.from(Array(20).keys()).map((el) => (
      <Skeleton.Paragraph key={el} maxWidth={window.innerWidth} size="md" />
    ))}
  </>
)
